module.exports = __webpack_public_path__ + "img/g-everything.fdfc2d22.jpg";